import { LANGUAGE_KEY } from "../constants";

// The languages the UI ships translations for, and the fallback used when the
// browser's preferred languages match none of them.
export const SUPPORTED_LANGUAGES = ["en", "es"];
export const DEFAULT_LANGUAGE = "en";

// Resolve the initial UI language: a previously stored manual choice wins;
// otherwise the first supported language among the browser's preferences; and
// finally the default. Spanish/English are matched on the primary subtag so
// regional variants (es-MX, en-GB, …) still resolve.
export function detectLanguage() {
  var stored = localStorage.getItem(LANGUAGE_KEY);
  if (stored && SUPPORTED_LANGUAGES.indexOf(stored) !== -1) {
    return stored;
  }

  var candidates =
    navigator.languages && navigator.languages.length
      ? navigator.languages
      : navigator.language
      ? [navigator.language]
      : [];

  for (var i = 0; i < candidates.length; i++) {
    var lang = (candidates[i] || "").toLowerCase();
    if (lang.indexOf("es") === 0) {
      return "es";
    }
    if (lang.indexOf("en") === 0) {
      return "en";
    }
  }

  return DEFAULT_LANGUAGE;
}
